import { Spin } from 'antd';
import ReactDOM from 'react-dom';
import './Loading.css';

/**
 * @param {Object} props - Component props
 * @param {string} props.tip - Loading message
 * @param {string} props.size - Spinner size ('small', 'default', 'large')
 * @param {string} props.type - Loading overlay type
 *   - 'fullscreen': Covers entire viewport (fixed position)
 *   - 'page': Covers page content area with header offset
 *   - 'container': Covers parent container (absolute position)
 *   - 'inline': Inline loading state for content areas
 *   - 'fullpage': Full page overlay for component lazy loading
 * @param {boolean} props.visible - Whether loading is visible (default: true)
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element|null} Loading component or null if not visible
 */
const Loading = ({ 
  tip = 'Loading...', 
  size = 'default', 
  type = 'container',
  visible = true,
  className = ''
}) => {
  if (!visible) return null;

  const containerClass = [
    'loading-container',
    `loading-container--${type}`,
    className
  ].filter(Boolean).join(' ');

  const content = (
    <div className={containerClass}>
      <Spin size={size} tip={tip} />
    </div>
  );
  if (type === 'fullscreen' || type === 'viewport') {
    return ReactDOM.createPortal(content, document.body);
  }
  return content;
};

export default Loading;